import PropTypes from 'prop-types';
import { BLOCKS } from '@contentful/rich-text-types';

import RichText from '../../../../Core/RichText';
import Pills from '../../../../Core/Pills';

import {
  Card,
  ImageWrapper,
  CardImage,
  Content,
  Title,
  Body,
  StyledCtas,
} from './styles';

const SpecialOfferCard = ({ data = null }) => {
  if (!data) return null;

  const {
    bodyCopy,
    heading,
    backgroundColor,
    imageDam,
    pillText,
    pillTextColor,
    pillBackgroundColor,
    ctas,
    theme,
  } = data;

  const header = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <Title>{children}</Title>,
      [BLOCKS.HEADING_2]: (_, children) => <Title>{children}</Title>,
    },
  };

  const subhead = {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_, children) => <Body>{children}</Body>,
    },
  };

  return (
    <Card
      className={`${theme}`}
      role="listitem"
      $backgroundColor={backgroundColor}
    >
      <ImageWrapper>{imageDam && <CardImage src={imageDam} />}</ImageWrapper>
      <Content>
        {pillText && (
          <Pills
            backgroundColor={pillBackgroundColor}
            textColor={pillTextColor}
          >
            {pillText}
          </Pills>
        )}
        {heading && <RichText document={heading} options={header} />}
        {bodyCopy && <RichText document={bodyCopy} options={subhead} />}
        {ctas && <StyledCtas ctas={ctas} direction="column" position="start" />}
      </Content>
    </Card>
  );
};

SpecialOfferCard.propTypes = {
  data: PropTypes.shape(),
};

export default SpecialOfferCard;
